import { graphql } from 'react-relay';

export const QDocumentHistoriesQuery = graphql`
  query QDocumentHistoriesQuery($documentId: ID!, $pagination: PaginationInput, $sort: HistorySort, $filter: HistoryFilterInput) {
    documentHistories(documentId: $documentId, pagination: $pagination, sort: $sort, filter: $filter) {
      histories {
        id
        entryKind
        savedAt
        action
        targetType
        targetName
        previousName
        author {
          firstName
          lastName
        }
        widget {
          widgetId
          placements {
            sectionLabel
            block
            isOrigin
          }
          isExternal
          sourceDocumentId
          sourceDocumentName
        }
        sourceOfferLabel
        milestoneType
        offerName
        offerVersion
        sourceOfferVersion
      }
      monthlyCounts {
        month
        count
      }
      pagination {
        page
        pages
        limit
        total
        hasNextPage
      }
    }
  }
`;
